import React from 'react';

/**
 * SectionHeader - Layout Component
 *
 * Reusable section title + subtitle pattern
 * Used for consistent section headers across the landing page
 */
export const SectionHeader = ({
  title,
  subtitle,
  accent,
  centered = true,
  className = '',
  ...props
}) => {
  const baseClass = 'tp-section-header';
  const centeredClass = centered ? 'tp-section-header--centered' : '';

  return (
    <div
      className={`${baseClass} ${centeredClass} ${className}`.trim()}
      {...props}
    >
      {title && (
        <h2 className="tp-section-header__title">
          {accent ? (
            <>
              {title.split(accent)[0]}
              <span className="tp-section-header__accent">{accent}</span>
              {title.split(accent)[1]}
            </>
          ) : (
            title
          )}
        </h2>
      )}

      {subtitle && (
        <p className="tp-section-header__subtitle">{subtitle}</p>
      )}
    </div>
  );
};

export default SectionHeader;
